/**
 * Doit être importé avant tout rendu de <Document> (react-pdf).
 * CRA/Webpack résout pdfjs-dist via le chemin relatif au présent module.
 */
import { pdfjs } from 'react-pdf';

const workerUrl = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
);
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl.toString();

export { pdfjs };
